import { ChangeEvent, FC, useState } from "react";
import SvgAdd from "../icons/Add";
import SvgClose from "../icons/Close";
import Button from "./Button";
import Input from "./Input";
import styles from "./MultipleInput.module.css";

interface InputWithAddProps {
  defaultValues?: string[];
  onChange: (values: string[]) => void;
  disabled?: boolean;
  isInvalid?: boolean | boolean[];
}

const MultipleInput: FC<InputWithAddProps> = ({ defaultValues, onChange, disabled, isInvalid }) => {
  const [values, setValues] = useState<string[]>(defaultValues ?? [""]);

  const handleAddInput = () => {
    const newValues = [...values, ""];
    setValues(newValues);
    onChange(newValues);
  };

  const handleRemoveInput = (index: number) => {
    if (values.length <= 1) return;

    const newValues = values.filter((_, i) => i !== index);
    setValues(newValues);
    onChange(newValues);
  };

  const handleInputChange = (index: number, value: string) => {
    const newValues = [...values];
    newValues[index] = value;
    setValues(newValues);
    onChange(newValues);
  };

  return (
    <div className={styles.container}>
      {values.map((value, index) => (
        <div key={index} className={styles.inputRow}>
          <Input
            value={value}
            disabled={disabled}
            onChange={(e: ChangeEvent<HTMLInputElement>) => handleInputChange(index, e.target.value)}
            isInvalid={Array.isArray(isInvalid) ? isInvalid[index] : isInvalid}
          />

          <div className={styles.buttons}>
            {index === values.length - 1 && (
              <Button buttonProps={{ onClick: handleAddInput, disabled }} glyph={SvgAdd} />
            )}

            {values.length > 1 && (
              <Button
                buttonProps={{ onClick: () => handleRemoveInput(index), disabled }}
                glyph={SvgClose}
                type="remove"
              />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default MultipleInput;
